module.exports = __webpack_public_path__ + "assets/certificate.9515b798a5d75ab3ff3e405801bc3631.svg";